$(document).ready(function(){
  
  var save_trinh_tu = "";
     $(".option-year").click(function(){
       var age = $(this).find(".date-box").text();
       $('.age_step_1').text(age);
        var trinh_tu_1 = $(this).find(".text-box").text();
        $('.text_tick:first').text(trinh_tu_1);
       save_trinh_tu = trinh_tu_1;
      
      
       if(trinh_tu_1 == "Mini Explorers"){
        $('.explorers:first').text(trinh_tu_1);
         $('.explorers:eq(1)').text("Little Learners");
         $('.explorers:eq(2)').text("Big Creative");
       }
       if(trinh_tu_1 == "Little Learners"){
        $('.explorers:first').text(trinh_tu_1);
         $('.explorers:eq(1)').text("Mini Explorers");
         $('.explorers:eq(2)').text("Big Creative");
       }
       if(trinh_tu_1 == "Big Creative"){
        $('.explorers:first').text(trinh_tu_1);
         $('.explorers:eq(1)').text("Mini Explorers");
          $('.explorers:eq(2)').text("Little Learners");
       }
    });

   $(".step2-option-subs").click(function(){
        var trinh_tu_2 = $(this).find(".subs").text();
        $('.text_tick:eq(1)').text(trinh_tu_2); 
     if(trinh_tu_2 == "Subscribe"){
        $('.one_time_gift:first').text(trinh_tu_2);
         $('.one_time_gift:eq(1)').text("One Time Gift");
          $('.one_time_gift:eq(2)').text("Gift Subscription");
       }
     if(trinh_tu_2 == "One Time Gift"){
        $('.one_time_gift:first').text(trinh_tu_2);
         $('.one_time_gift:eq(1)').text("Subscribe");
          $('.one_time_gift:eq(2)').text("Gift Subscription");
     }
     if(trinh_tu_2 == "Gift Subscription"){
        $('.one_time_gift:first').text(trinh_tu_2);
         $('.one_time_gift:eq(1)').text("Subscribe");
         $('.one_time_gift:eq(2)').text("One Time Gift");
     }
    });
   $(".option-search-step-three").click(function(){
        var trinh_tu_3 = $(this).find(".subs").text();
        $('.text_tick:eq(2)').text(trinh_tu_3); 
     if(trinh_tu_3 == "Monthly"){
        $('.every_months:first').text(trinh_tu_3);
        $('.every_months:eq(1)').text("Every 3 Months");
        $('.every_months:eq(2)').text("Every 6 Months");
       $('.every_months:eq(3)').text("Every 12 Months");
       }
     if(trinh_tu_3 == "Every 3 Months"){
        $('.every_months:first').text(trinh_tu_3);
        $('.every_months:eq(1)').text("Monthly");
        $('.every_months:eq(2)').text("Every 6 Months");
       $('.every_months:eq(3)').text("Every 12 Months");
       }
     if(trinh_tu_3 == "Every 6 Months"){
        $('.every_months:first').text(trinh_tu_3);
        $('.every_months:eq(2)').text("Every 3 Months");
        $('.every_months:eq(1)').text("Monthly");
       $('.every_months:eq(3)').text("Every 12 Months");
       }
     if(trinh_tu_3 == "Every 12 Months"){
        $('.every_months:first').text(trinh_tu_3);
        $('.every_months:eq(1)').text("Monthly");
        $('.every_months:eq(2)').text("Every 3 Months");
       $('.every_months:eq(3)').text("Every 6 Months");
       }
    });
  //next
  $("#show").click(function(){
    $("div .section-middle").addClass("important");
    $("div .box-finder-step-two").addClass("step2");
        $("div .box-finder-step-two").removeClass("important");
        $("div .border-step1").addClass("important");
        $("div .border-step2").addClass("step2");
        $(".number_tick:first").addClass("circle");
        $(".number_tick:first").css("font-size", "0");
        $(".process_tick:first").css("cursor", "pointer");
  });
  $("#show2").click(function(){
      $("div .box-finder-step-two.step2").addClass("important");
      $("div .step-three").addClass("step2");
      $("div .step-three").removeClass("important");
        $(".number_tick:eq(1)").addClass("circle");
    $(".number_tick:eq(1)").css("font-size", "0");
    $(".process_tick:eq(1)").css("cursor", "pointer");
  });

  $("#show3").click(function(){
    $("div .step-three.step2").addClass("important");
    $("div .finder-four").addClass("step2");
        $("div .finder-four").removeClass("important");
    $("div .border-step1").removeClass("important");
    $("div .border-step2").addClass("important");
    $(".number_tick:eq(2)").css("font-size", "0");
    $(".number_tick:eq(2)").addClass("circle");
    $(".number_tick:eq(3)").addClass("circle");
    $(".process_tick:eq(2)").css("cursor", "pointer");
    $(".process_tick_result").css("cursor", "pointer");
    
  });

  //back
  $("#back").click(function(){
    $("div .finder-four.step2").addClass("important");
    $("div .step-three").addClass("step2");
    $("div .step-three").removeClass("important");
        $("div .border-step1").addClass("important");
        $("div .border-step2").addClass("step2");
        $("div .border-step2").removeClass("important");
            
       
  });

  $("#back2").click(function(){
    $("div .step-three.step2").addClass("important");
    $("div .box-finder-step-two").addClass("step2");
    $("div .box-finder-step-two").removeClass("important");
        $("div .border-step1").addClass("important");
        $("div .border-step2").addClass("step2");
        $("div .border-step2").removeClass("important");
    if($(".option_one_gift_time_essentials").hasClass('option_js_step_2')){
        $(".option_one_gift_time_essentials").removeClass('option_js_step_2');
            }
    if($(".option-search-step-three_prepay").hasClass('option_js_step_2')){
        $(".option-search-step-three_prepay").removeClass('option_js_step_2');
            }
    $('.date_add_to_cart').addClass('step_3_none');
    
  });

  $("#hide1").click(function(){
    $("div .box-finder-step-two.step2").addClass("important");
    $("div .section-middle").addClass("step2");
    $("div .section-middle").removeClass("important");
        $("div .border-step1").removeClass("important");
        $("div .border-step1").addClass("step2");
        $("div .border-step2").addClass("important");
  });

  //xu ly click lan 2
  $(".option-year ").click(function(){
    
    if($(this).hasClass('option_js')){
      $(".option-year ").removeClass('option_js');
    } else {
      $(".option-year ").removeClass('option_js');
      $(this).addClass('option_js');
    }
  });

  $(".js-option-search").click(function(){
      if($(this).hasClass('option_js')){
        $(".js-option-search").removeClass('option_js');
      } else {
        $(".js-option-search").removeClass('option_js');
        $(this).addClass('option_js');
      }
  });

    //disable and enable button
  $('#show').prop('disabled', true);
  $(".option-year ").click(function(){
    var object = $('.option-year ');
    var step_2 = $('.js-option-search ');
    if ($(object).hasClass('option_js') || $(step_2).hasClass('option_js')){         
      $('#show').prop('disabled', false);
      $(".selection").addClass('important');
    }else {
      $('#show').prop('disabled', true);
      $(".selection").removeClass('important');
    }
  });

  $(".js-option-search").click(function(){
    if ($(this).hasClass('option_js') || $('.option-year ').hasClass('option_js')){
      $('#show').prop('disabled', false);
      $(".selection").addClass('important');
    }else {
      $('#show').prop('disabled', true);
      $(".selection").removeClass('important');
    }
  });

  //step 2
  $(".step2-option-subs").click(function(){
    if($(this).hasClass('option_js_step_2')){
      $(".step2-option-subs").removeClass('option_js_step_2');
      
    }else{
      $(".step2-option-subs").removeClass('option_js_step_2');
      $(this).addClass('option_js_step_2');
    }
  });

        $('#show2').prop('disabled', true);
        $(".one_time_gift_mutiple").click(function(){
        if($(this).hasClass('option_js_step_2')){
            $(".one_time_gift_mutiple").removeClass('option_js_step_2');
            }
        else{
            $(".one_time_gift_mutiple").removeClass('option_js_step_2');
            $(this).addClass('option_js_step_2');
        }
       });
    $(".option-search-step-three").click(function(){
            var object = $('.option-search-step-three');
            if ($(this).hasClass('option_js_step_2')){
              $(".option-search-step-three").removeClass('option_js_step_2');
            } else {
              $(this).addClass('option_js_step_2');
        }
    });
//  one time
    $(".option-search-step-three_suscribe").click(function(){
    if($(this).hasClass('option_js_step_2')){
      $(".option-search-step-three_suscribe").removeClass('option_js_step_2');
    }else{
      $(".option-search-step-three_suscribe").removeClass('option_js_step_2');
      $(this).addClass('option_js_step_2');
    }
    $(".option-search-step-three-suscribe-single").click(function(){
    if($(this).hasClass('option_js_step_2')){
      $(".option-search-step-three-suscribe-single").removeClass('option_js_step_2');
    }else{
      $(this).addClass('option_js_step_2');
    }
    })
    $(".option-search-step-three-suscribe-present").click(function(){
    if($(this).hasClass('option_js_step_2')){
      $(".option-search-step-three-suscribe-present").removeClass('option_js_step_2');
    }else{
      $(this).addClass('option_js_step_2');
    }
    })
    
      
  });
  //step 3
   $('#show3').prop('disabled', true);
  
  $("#show3").click(function(){
    $(".text_tick").click(function(){
        $(".form_finder_box").addClass("form_finder_box_show");
    $(".form_finder_box").removeClass("form_finder_box");
    });
    });
   $(".close_popup").click(function(){
        $(".form_finder_box_show").addClass("form_finder_box");
    $(".form_finder_box_show").removeClass("form_finder_box_show");
     
  });
  //save
        var value = $("#mySelect").find(":selected").text();
            $("#save").click(function(){        
            setTimeout(function() {
                $(".form_finder_box_show").addClass("form_finder_box");
                $(".form_finder_box_show").removeClass("form_finder_box_show");

            }, 1500);
    });
    //tick
     $(".check_box_v ").click(function(){
    if($(this).hasClass('popup_tick')){
      $(".check_box_v ").removeClass('popup_tick');
      $(".check_box_v").css("border", "1px solid rgba(0,0,0,.25)");
    } else {
      
      $(this).addClass('popup_tick');
      $(".check_box_v").css("border", "1px solid green");
    }
  });
 
  var dateCurrent = new Date();
  var monthCurrent = (dateCurrent.getMonth()+1);
  var yearCurent = dateCurrent.getFullYear();
    var month_step1 = "";
    var year_step1 = "";
  $("#month-step-one ").change(function(){
  var  month_step = $("#month-step-one").find(":selected").val();
    month_step1 = month_step;
    $(".option-year ").removeClass('option_js');
  })
  
   $("#year-step-one").change(function(){
     $('#show').prop('disabled', false);
     $(".option-year ").removeClass('option_js');
   var year_step = $("#year-step-one").find(":selected").val();
     year_step1 = year_step;
     if(monthCurrent<month_step1){
        var year = yearCurent - year_step1;
     }
     else{
        var year = yearCurent - year_step1 + 1;
     }
  })
   
   $(".step2-option-subs").click(function(){
      var check_subs = $(this).find(".subs").text();
     // check click Subscribe
       if(check_subs == "Subscribe"){
         $('#show2').prop('disabled', false);
         $(".gift-subscription ").removeClass('step_3_none');
    // when click from one-time-gift to gift-subscription   
         $(".one-time-gift ").addClass('step_3_none');
         $(".single_step_2 ").addClass('step_3_none');
         $(".one-time-gift").addClass('step_3_none');
         $(" .option-search-step-three_suscribe").removeClass('option_js_step_2');
         $(".frequency ").addClass('step_3_none');
         $(".payment_type ").addClass('step_3_none');
         $(".first_box_themee ").addClass('step_3_none');
         $(".gift-subscription ").addClass('step_3_none');
         $(" .one_time_gift_mutiple").removeClass('option_js_step_2');
         $(".first_box_themee").removeClass('step_3_none');
     }
     //check click Subscription
     if(check_subs == "Gift Subscription"){
       $('#show2').prop('disabled', true);
       $(".gift-subscription ").removeClass('step_3_none');
    // when click from one-time-gift to gift-subscription   
       $(".one-time-gift ").addClass('step_3_none');
       $(".single_step_2 ").addClass('step_3_none');
       $(".one-time-gift").addClass('step_3_none');
       $(" .option-search-step-three_suscribe").removeClass('option_js_step_2');
     }

    //  check click one time gifft
    if(check_subs == "One Time Gift"){
      $('#show2').prop('disabled', true);
      $(".one-time-gift ").removeClass('step_3_none');
      // when click from gift-subscription to one-time-gift  
      $(".frequency ").addClass('step_3_none');
      $(".payment_type ").addClass('step_3_none');
      $(".first_box_themee ").addClass('step_3_none');
      $(".gift-subscription ").addClass('step_3_none');
      $(" .one_time_gift_mutiple").removeClass('option_js_step_2');
     }
    });
       //check click Subscription
//   check click 2  one_time_gift_mutiple_frequency
        $(".one_time_gift_mutiple_frequency").click(function(){
        if($(this).hasClass('option_js_step_2')){
            $(".one_time_gift_mutiple_frequency").removeClass('option_js_step_2');
            
            }
        else{
            $(".one_time_gift_mutiple_frequency").removeClass('option_js_step_2');
            $(this).addClass('option_js_step_2');
            
        }
       });
//   click next step 2
    $(".option-search-step-three").click(function(){
    var object = $('.option-search-step-three');
    if ($(object).hasClass('option_js_step_2')){
      $('#show2').prop('disabled', false);
    } else {
      $('#show2').prop('disabled', true);
    }
  });
//  khi bo chon optipn gift sub 
  $(".step2-option-subs").click(function(){
    if(!$(this).hasClass('option_js_step_2')){
      $(".gift-subscription ").addClass('step_3_none');
      $(".frequency ").addClass('step_3_none');
      $(".payment_type ").addClass('step_3_none');
      $(".first_box_themee ").addClass('step_3_none');
      $(".one_time_gift_mutiple").removeClass('option_js_step_2');
      $(".one_time_gift_mutiple_frequency").removeClass('option_js_step_2');
      $(".option-search-step-three").removeClass('option_js_step_2');
      $(".one-time-gift").addClass('step_3_none');
    }
  })
    $(".one_time_gift_mutiple").click(function(){
    if($(this).hasClass('option_js_step_2')){
      $(".frequency").removeClass('step_3_none');
      $(".one_time_gift_mutiple_frequency").removeClass('option_js_step_2');
      $(".option-search-step-three").removeClass('option_js_step_2');   
    }
      else{
        $(".frequency").addClass('step_3_none');
        $(".payment_type ").addClass('step_3_none');
        $(".first_box_themee ").addClass('step_3_none');
        }
  })
   $(".one_time_gift_mutiple_frequency").click(function(){
    if($(this).hasClass('option_js_step_2')){
      $(".payment_type").removeClass('step_3_none');
      $(".option-search-step-three").removeClass('option_js_step_2');   
    }
      else{
             
        $(".payment_type").addClass('step_3_none');
        $(".first_box_themee ").addClass('step_3_none');
        }
  })
   $(".option-search-step-three").click(function(){
    if($(this).hasClass('option_js_step_2')){
      $(".first_box_themee").removeClass('step_3_none');
    }
     else{           
      $(".first_box_themee").addClass('step_3_none');
        }
  })
   
  function checkInput(){
  if($(".name").val() !=  "" && $(".dob").val() != "" && $(".message_next").val() != "" && $(".select_line_theme").val() != ""){
             $('#show3').prop('disabled', false);
     }
     else{
     $('#show3').prop('disabled', true);
     }
  }
   $(".select_line_theme").change(function(){
     checkInput();
   });
  $(".name").keyup(function(){
   checkInput();
  });
   $(".dob").keyup(function(){
    checkInput();
   })
  $(".message_next").keyup(function(){
    checkInput();
  })

//   check monthly
  $(".frequency .one_time_gift_mutiple_frequency").click(function(){
    var monthly = $(this).find(".subs_three_mutiple").text();
    if ( monthly == "Every other month"){
      $(".option-search-step-three:last-child").css("display","none");
    }
    else{
        $(".option-search-step-three:last-child").css("display","block");
    }
  })

       //check click single or mutiple
  $("#multiple-single_click").click(function(){
      $(this).parent(".one-time-gift").siblings(".single_step_2").addClass('step_3_none');
  })
    $("#single_click").click(function(){
        $(this).parent(".one-time-gift").siblings(".single_step_2").removeClass('step_3_none');
      if($(this).hasClass('option_js_step_2')){
        $(".first_box_themee").removeClass('step_3_none');
      }
       else{           
        $(".first_box_themee").addClass('step_3_none');
          }
  })
    //check disable button
    $('#show2').prop('disabled', true);
      $(".option-search-step-three-suscribe-single").click(function(){
      var object = $('.option-search-step-three-suscribe-single');
      if ($(object).hasClass('option_js_step_2')){
       $('#show2').prop('disabled', true);
      } else {
         $('#show2').prop('disabled', false);

      }
  });
  // khi bo chon onr time gift
        $(".step2-option-subs").click(function(){
    if(!$(this).hasClass('option_js_step_2')){
        $(".single_step_2").addClass('step_3_none');
        $(".option-search-step-three_suscribe").removeClass('option_js_step_2');
        $(".option-search-step-three-suscribe-single").removeClass('option_js_step_2');
    }
  })
      $(".option-search-step-three_suscribe").click(function(){
        if(!$(this).hasClass('option_js_step_2')){
          $(".option-search-step-three-suscribe-single").removeClass('option_js_step_2');
          $(".single_step_2").addClass('step_3_none');
    }
  })

  // xu ly dieu kien\
      
    var option_year_value= "" ;
    var option_step_2= "" ;
    var option_step_2_1= "" ;
    var option_step_2_2= "" ;
    var option_step_2_3= "" ;
  $(".flex-option ").click(function(){
    var option_year = ($(this).attr("data-condition"));
    option_year_value= option_year;
    console.log(option_year)
  });
   $(".step2-option-subs ").click(function(){
    var data_step_2 = ($(this).attr("data-condition"));
     option_step_2 = data_step_2;
     console.log(data_step_2)
     
  });
   $(".one_time_gift_mutiple").click(function(){
    var data_step_2_1 = ($(this).attr("data-condition"));
     option_step_2_1 = data_step_2_1;
     console.log(data_step_2_1)
  });
     $(".one_time_gift_mutiple_frequency").click(function(){
    var data_step_2_2 = ($(this).attr("data-condition"));
       option_step_2_2 = data_step_2_2;
       console.log(data_step_2_2)
  });
     $(".option-search-step-three").click(function(){
    var data_step_2_3 = ($(this).attr("data-condition"));
       option_step_2_3 = data_step_2_3;
       console.log(data_step_2_3)
  });
 // lay dieu kien
   var conditions = $('.conditions').text();
//   console.log(conditions)
    $("#show2").click(function(){
    var txt = option_year_value.trim() + "," + option_step_2.trim() + "," + option_step_2_1.trim() + "," + option_step_2_2.trim() + "," + option_step_2_3.trim();
      console.log(txt)
    var conditionsArray = conditions.split("},{");
        console.log(conditionsArray);
    for(var i=0;i < conditionsArray.length; i++) {
      var conditionCheck = conditionsArray[i].replaceAll('{','');
      var conditionCheck = conditionsArray[i].replaceAll('}','');
      var conditionCheckArray = conditionCheck.split(":");
      if(conditionCheckArray[1].replaceAll('"','') == txt) {
        var keyResult = conditionCheckArray[0].replaceAll('"','');
        keyResult = keyResult.replaceAll('{','');
        keyResult = keyResult.replaceAll('"','');
        keyResult = keyResult.replaceAll("'",'');
        console.log(keyResult)
      }
    }
    
    //result 
  // layy ket qua        
  	var results = $('.results').text();
    var result = "";
//   console.log(results)
    var resultsArray = results.split("},");
    for(var j=0;j < resultsArray.length; j++) {
      var resultToCheck = resultsArray[j];
      var resultToCheckArray = resultToCheck.split(":{");
//       console.log(resultToCheckArray)
      var keyToCheck = resultToCheckArray[0].replaceAll('{','');
      keyToCheck = keyToCheck.replaceAll('"','');
//       console.log(keyToCheck)
       if(keyToCheck == keyResult ) {
        result = resultToCheckArray[1].split('","');
      }

    }
    if(result && result.length > 0) {
            for(var x=0;x < result.length; x++) {
              // cat tu ":"
              var data = result[x].split('":"');
              // cat  tu dau :
              let arr = data[0].split(":");
              //lay key 
              let key = arr[0].replaceAll('"','');
              //lay value
              var value = data[1];
              let value1 = arr[1];

              if(key == 'image' ){
                var image = value;
              $('.image-box-top img').attr('src',image);
              }
              if(key == 'image-icon' ){
                var image_icon = value;
                  $('.img-position img ').attr('src',image_icon)
              }
              if(key == 'title' ){
                var title = value1.replace('"','');  
               $('.number-year').text(title);
              }
              if(key == 'sub-title'){
                  var sub_title = value1.replace('"',''); 
                $('.little-learner').text(sub_title);
              }
              if(key == 'description'){
                var description = value1.replaceAll('"','');
                var eval_description = description.replaceAll('}','');
                var final_description = eval_description.replace("'",'');
                $('.content-text').text(final_description);
              }
            }        
    }
          }) 
    

});

